define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Зарегистрировать другого пользователя",

    'incrowd_stats.num_responders': "{{num}} экспертов в области здравоохранения",
    'incrowd_stats.num_answers': "Отвечено {{num}} вопросов",
    'incrowd_stats.time_to_complete': "{{num}} минут, чтобы закончить средний опрос",

    // INCROWD
    'incrowd.about': "О нас",
    'incrowd.contact': "Контакты",
    'incrowd.press': "Пресса",
    'incrowd.careers': "Вакансии",
    'incrowd.terms': "Правила",
    'incrowd.t_and_c': "Правила и условия",
    'incrowd.faq': "Вопрос-ответ",
    'incrowd.privacy': "Конфиденциальность",
    'incrowd.copyright': "{{year}} InCrowd Inc, все права защищены",
    'incrowd.blog': "Блог",
    'incrowd.support': "Служба поддержки",
    'incrowd.info.ios': "Знаете ли вы, что терапевты сообщества InCrowd могут теперь посылать вопросы напрямую своим коллегам? Попробуйте это сейчас, используя <InCrowd iOS App>!",
    'incrowd.refer': "Вам нравится проходить наши опросы? <Приведите друга> сегодня, чтобы он присоединился к нашей группе, и вы оба получите по 10 $ (или в эквиваленте). Как только ваш коллега пройдет опрос, он получит дополнительный бонус!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Мини-опросы —",
    'getstarted.encourage.title.two': "максимум воздействия",
    'getstarted.encourage.subtitle': "Присоединяйтесь к тысячам квалифицированных профессионалов в области медицины, которые содействуют развитию новых продуктов и курсов лечения пациентов через простые мини-опросы, и мы вам за это платим!",
    'getstarted.encourage.redirect_to_solutions': "Не являетесь специалистом в области здравоохранения, но хотите узнать подробнее об InCrowd?",
    'getstarted.actions.title': "Вы квалифицированный медицинский работник?",
    'getstarted.actions.subtitle': "Зарегистрируйтесь сегодня и начните зарабатывать деньги, проходя мини-опросы, касающиеся здравоохранения",
    'getstarted.button.continue': "Начать",
    'getstarted.referral': "Зарегистрируйтесь, чтобы заработать деньги за опросы плюс реферальный бонус от %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Нам нужны от вас некоторые детали, чтобы создать ваш аккаунт.",
    'details.profile_details': "Данные профиля",
    'details.address_information': "Контактные данные",
    'details.professional_info': "Профессиональные данные",
    'details.heading.finally': "…и наконец",
    'details.how_receive_surveys': "Как бы вы хотели получать опросы?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Основы",
    'professionchoice.encourage.subtitle': "Не видите вашу профессию? Дайте нам знать, <здесь> чтобы удостовериться, что вы оповещены о том, что ваша профессия добавлена.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Кто вы?",
    'authentication.encourage.subtitle': "InCrowd необходимо удостоверить вашу личность, но мы никогда не раскроем или распространим ваши личные данные третьим лицам.",
    'authentication.actions.select_notifications': "Выберите, как бы вы хотели получать наши мини-опросы",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Пожалуйста, ожидайте, пока идет подтверждение ваших данных",
    'validation.please_answer': "Пожалуйста, ответьте на следующие вопросы, чтобы помочь нам подтвердить ваши персональные данные",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Подтверждение",
    'confirmation.validation_success.subtitle': "Ваша регистрация завершена, добро пожаловать в InCrowd! Скоро вы получите подтверждение по электронной почте и/или СМС. Спасибо за регистрацию!",
    'confirmation.validation_error.title': "Требуется дополнительная информация",
    'confirmation.validation_error.subtitle': "Извините, %{userFirstName}, возникла проблема при подтверждении ваших персональных данных.",
    'confirmation.actions_title': "Что дальше?",
    'confirmation.go_to_your_profile': "Перейдите в ваш профиль",
    'confirmation.validation_success.actions_subtitle': "Вы начнете получать наши микро-опросы продолжительностью 5-10 минут через пару дней по электронной почте или СМС. Пока не разрешили получение опросов по СМС? Вы можете изменить свои настройки связи в любое время в вашем профиле InCrowd.",
    'confirmation.validation_error.actions_subtitle': "Воспользуйтесь всплывающим чатом в нижней части экрана, чтобы обратиться за помощью в InCrowd.",
    'confirmation.referral.info.1': "В течение %{payoutBusinessDays} рабочих дней после вашего участия во 2-м опросе, вы и человек, который направил вас, <получите %{currency}%{referralBonusAmount}>. %{currency}%{referralBonusAmount} будет зачислено на ваш счет вознаграждений. Вы можете войти в ваш <профиль> в любое время, чтобы обновить настройки, просмотреть ваши вознаграждения или получить доступ к любыми открытым опросам, к участию в которых вас пригласили.",
    'confirmation.referral.info.2': "Есть вопросы? <Пообщайтесь с нами в чате>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Вы квалифицированы?",
    'regftr.markets.accepting': "Ответы InCrowd сейчас принимает:",
    'regftr.peers.title': "Коллеги",
    'regftr.peers.subtitle': "Сравните ваши ответы с ответами ваших коллег и усвойте что-нибудь новое из их ответов.",
    'regftr.invites.title': "Приглашения",
    'regftr.invites.subtitle': "Получайте новые приглашения на прохождение мини-опросов по эл. почте или по телефону, чтобы максимизировать свои доходы.",
    'regftr.earnings.title': "Доходы",
    'regftr.earnings.subtitle': "Управляйте и следите за вашими доходами и информацией о платежах.",
    'regftr.stats.title': "Статистика",
    'regftr.stats.subtitle': "Получите доступ к панели с информацией о всех ваших опросах и подробностями о пользователе.",

    'contextual_help.sms': "Вы будете получать SMS-уведомления об открытых микроопросах. При помощи SMS вы сможете быстрее получать доступ к опросам и зарабатывать больше наград. Ваша информация содержится в полной конфиденциальности и используется исключительно в целях приглашения к участию в опросах.",
    'contextual_help.specialty': "Пожалуйста, укажите только те специальности, которые связаны с вашим NPI, где вы закончили аспирантуру, или области медицины, которые относятся к вашей основной специальности. Если вам потребуется внести изменения в свои специальности в будущем, обратитесь по адресу support@incrowdnow.com.",
    // USER
    'user(s)': "Пользователь |||| Пользователи",
    'user.login': "Вход",
    'user.logout': "Выход",
    'user.register': "Зарегистрироваться",
    'user.invitations': "Приглашения",
    'user.email': "Эл. почта",
    'user.pass_word': "Пароль",
    'user.mobile': "Номер мобильного телефона",
    'user.mobile.hint': "Пожалуйста, введите код страны (+%{phoneCode} для %{countryName})",
    'user.title': "Обращение",
    'user.title_with_example': "Обращение (например, Д-р, Г-жа, Г-н)",
    'user.first_name': "Имя",
    'user.last_name': "Фамилия",
    'user.middle_name': "Второе имя",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Пользователь",
    'user.anonymous_admin': "Админ",
    'user.dashboard': "Панель",
    'user.profile': "Профиль",
    'user.profile.picture.upload': "Загрузить фото профиля",
    'user.profile.picture.change': "Изменить",
    'user.primary_lang': "Родной язык",
    'user.primary_lang?': "Какой ваш родной язык?",
    'user.survey_langs?': "Какими языками вы владеете свободно?",
    'user.notify_email': "Уведомлять по эл. почте",
    'user.notify_mobile': "Уведомлять по телефону",
    'user.contact_support': "Служба поддержки",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Пожалуйста, <свяжитесь с нами>.",
    'user.profession': "Профессия",
    'user.profession?': "Какая ваша профессия?",
    'user.join_now': "Присоединиться сейчас",
    'user.welcome_back': "С возвращением!",
    'user.not_a_member?': "Еще не зарегистрированы?",
    'user.accept_terms': "Принять условия",
    'user.accept_terms.yes': "Я принимаю <правила и условия>",
    'user.remember_me': "Запомнить меня на этом устройстве",
    'user.time_zone': "Часовой пояс",
    'user.payment.policy': "Всякий раз, когда вы накопите наград на сумму 25%{currency}, вы получите уведомление и сможете выбрать способ платежа из наших вариантов способов платежей в вашем профиле InCrowd. Есть вопросы? Свяжитесь с нами с использованием окна чата ниже.",
    'user.country.live_work?': "В какой стране вы проживаете и работаете?",
    // FORMS
    'form.button.back': "Назад",
    'form.button.next': "Следующее",
    'form.button.cancel': "Отменить",
    'form.button.submit': "Отправить",
    'form.button.continue': "Продолжить",
    'form.button.close': "Закрыть",
    'form.button.go!': "Вперед!",
    'form.button.complete!': "Завершить сейчас!",
    'form.button.update': "Обновить",
    'form.button.finish': "Закончить",
    'form.button.search': "Поиск",
    'form.button.end': "Конец",
    'form.search.no_matches': "По запросу ничего не найдено",
    'form.confirm_email': "Подтвердить эл. почту",
    'form.confirm_pass_word': "Подвердить пароль",
    'form.required_fields': "Поля, обязательные для заполнения",
    'form.nothing_selected': "Ничего не выбрано",
    'form.confirm_field': "Подтвердить %{formFieldLabel}",
    'form.choice.n/a': "Нет данных",
    'form.choice.yes': "Да",
    'form.choice.no': "Нет",
    'form.choice.blank_for_all': "Оставьте пустым, чтобы выбрать все",
    'form.choices.select_all': "Выбрать все",
    'form.choices.deselect_all': "Снять выбранное",
    'form.field.private': "Скрытое поле",

    // USER ERRORS
    'user.error.dup_email': "Другой пользователь уже зарегистрирован с данным адресом эл. почты. <Войти вместо?>",
    'user.error.dup_sms': "Другой пользователь зарегистрирован с таким же номером телефона",
  }
})
